import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/models/apiResponse';
import { UserProfile } from 'src/app/models/userProfile';
import { settings } from '../globals/settings';

@Injectable({
	providedIn: 'root'
})
export class AuthService {

	returnUrl: string | null | undefined;

	constructor(
		private readonly _http: HttpClient,
		private readonly _route: ActivatedRoute,
	)
	{ 
		this._route.queryParamMap.subscribe((params: ParamMap) => {
			this.returnUrl = params.get(settings.returnUrlParamName) ?? settings.endpoints.gameApp;
		});
	}

	public loginByEmail(email: string, password: string): Observable<any>{
		const httpOptions = {
			withCredentials: true
		};
		return this._http.post(settings.endpoints.authRoot + "/api/users/login", { email, password } , httpOptions);
	}
	
	public registerLocalUser(email: string, password: string, firstName: string, lastName: string): Observable<any> {
		const httpOptions = {
			withCredentials: true
		};
		return this._http.post(settings.endpoints.authRoot + "/api/users/register", { email, password, firstName, lastName }, httpOptions);
	}

	public getUserProfile(): Observable<ApiResponse<UserProfile>> {
		const httpOptions = {
			withCredentials: true
		};
		return this._http.get<ApiResponse<UserProfile>>(settings.endpoints.authRoot + "/api/users/profile", httpOptions);
	}

	public logout(): Observable<any> {
		const httpOptions = {
			withCredentials: true
		};
		return this._http.get(settings.endpoints.authRoot + "/api/users/logout", httpOptions);
	}

	public get loginByGoogle(): string {
		return settings.endpoints.loginByGoogle;
	}

	public generateEmailConfirmationLink(): Observable<any> {
		const httpOptions = {
			withCredentials: true
		};
		return this._http.post(settings.endpoints.authRoot + "/api/users/email/confirmation-link", {  }, httpOptions);
	}

	public confirmEmail(confirmationCode: string): Observable<any> {
		const httpOptions = {
			withCredentials: true
		};
		return this._http.patch(settings.endpoints.authRoot + "/api/users/email/confirm", { confirmationCode }, httpOptions);
	}

	public resetPassword(email: string, resetCode: string, newPassword: string): Observable<any> {
		const httpOptions = {
			withCredentials: true
		};
		return this._http.patch(settings.endpoints.authRoot + "/api/users/password/reset", { email, resetCode, newPassword }, httpOptions);
	}

	public changePassword(currentPassword: string, newPassword: string): Observable<any> {
		const httpOptions = {
			withCredentials: true
		};
		return this._http.patch(settings.endpoints.authRoot + "/api/users/password/change", { currentPassword, newPassword }, httpOptions);
	}

	public generatePasswordResetLink(email: string): Observable<any> {
		const httpOptions = {
			withCredentials: true
		};
		return this._http.post(settings.endpoints.authRoot + "/api/users/password/reset-link", { email }, httpOptions);
	}
}
